import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';


const gsiApi = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_GSI
})

const get = param => trackPromise(gsiApi.get(param));
const post = (param, body) => trackPromise(gsiApi.post(param, body));
const put = (param, body) => trackPromise(gsiApi.put(param, body));
const del = param => trackPromise(gsiApi.delete(param));

const getToken = async (request) => {
  const body = `client_id=${process.env.REACT_APP_CLIENT}&grant_type=client_credentials&client_secret=${process.env.REACT_APP_BASEURL_GSI_TOKEN}`
  const url = process.env.REACT_APP_BASE_URL_GSI_TOKEN
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body
  });
  const data = await response.json()

  request.headers['Authorization'] = 'Bearer ' + data.access_token;

  window.localStorage.setItem('gsiToken', 'Bearer ' + data.access_token);
  return request;
}

gsiApi.interceptors.request.use(
  async (request) => {
    request.headers['Authorization'] = window.localStorage.getItem('gsiToken');
    if (!request.headers.Authorization || request.headers.Authorization === 'Bearer undefined') {
      request = await getToken(request);
    }
    return request
  },
  error => {
    console.log('error')
  }
);

gsiApi.interceptors.response.use(response => {
  return response;
}, async err => {
  if (err.response.status === 401) {
    let originalReq = err.config;

    originalReq._retry = true;

    originalReq = await getToken(originalReq);

    return axios(originalReq);
  }
  else {
    return err.response
  }


}
);

export default {
  get,
  post,
  put,
  del
};